// Mock data for Vrinaa Occasions website

export const heroContent = {
  title: "Vrinaa Occasions",
  subtitle: "Transforming Moments into Timeless Memories",
  description: "Premium event decoration services in Kolkata. We craft extraordinary experiences for birthdays, anniversaries, corporate events, and every celebration in between.",
  heroImage: "https://images.pexels.com/photos/14703685/pexels-photo-14703685.jpeg"
};

export const eventCategories = [
  {
    id: 1,
    title: "Birthday Parties",
    description: "Create magical birthday celebrations with our professional decoration designs for intimate gatherings and special milestones.",
    image: "https://images.unsplash.com/photo-1755704282977-340323fa52df",
    features: ["Custom themes", "Floral arrangements", "Table decorations", "Photo backdrops"]
  },
  {
    id: 2,
    title: "Wedding & Anniversary",
    description: "Beautiful intimate Indian wedding decorations with traditional mandap setups perfect for home ceremonies and small venues.",
    image: "https://images.unsplash.com/photo-1587271636175-90d58cdad458",
    features: ["Small mandap decoration", "Traditional elements", "Home ceremonies", "Floral setups"]
  },
  {
    id: 3,
    title: "Engagement Ceremonies",
    description: "Beautiful engagement decoration with personalized touches for your special moment in intimate settings.",
    image: "https://images.unsplash.com/photo-1744891471118-f74c0453cd21",
    features: ["Colorful setups", "Traditional decor", "Photo opportunities", "Custom styling"]
  },
  {
    id: 4,
    title: "Office & Corporate Parties",
    description: "Professional decorations for small corporate celebrations, team parties, and office milestone events.",
    image: "https://images.unsplash.com/photo-1768776183877-e8f3dfc91f40",
    features: ["Elegant table setups", "Professional themes", "Office parties", "Corporate events"]
  },
  {
    id: 5,
    title: "Baby Showers",
    description: "Adorable and charming decorations for welcoming your little one with cute themes and pastel colors.",
    image: "https://images.pexels.com/photos/36079150/pexels-photo-36079150.jpeg",
    features: ["Baby themes", "Pastel decorations", "Cute props", "Balloon arrangements"]
  },
  {
    id: 6,
    title: "Special Milestones",
    description: "Celebrate life's special moments with custom decoration solutions for any milestone celebration.",
    image: "https://images.unsplash.com/photo-1758870041148-31d28fdf34d9",
    features: ["Number displays", "Custom designs", "Themed setups", "Personalized touches"]
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1755704282977-340323fa52df",
    category: "Birthday",
    alt: "Elegant birthday party decoration with florals"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1587271636175-90d58cdad458",
    category: "Wedding",
    alt: "Intimate Indian wedding mandap ceremony"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1758870041148-31d28fdf34d9",
    category: "Birthday",
    alt: "Illuminated number display with balloons"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1523438885200-e635ba2c371e",
    category: "Wedding",
    alt: "Small garden mandap wedding decoration"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1768776183877-e8f3dfc91f40",
    category: "Corporate",
    alt: "Elegant party table decoration setup"
  },
  {
    id: 6,
    url: "https://images.pexels.com/photos/36079150/pexels-photo-36079150.jpeg",
    category: "Baby Shower",
    alt: "Baby shower teddy bear balloon decoration"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1744891471118-f74c0453cd21",
    category: "Wedding",
    alt: "Colorful intimate Indian wedding mandap"
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1751257752208-64b3e929a125",
    category: "Corporate",
    alt: "Elegant table decoration for corporate events"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    event: "25th Wedding Anniversary",
    rating: 5,
    text: "Vrinaa Occasions transformed our anniversary celebration into a magical evening. The attention to detail and elegant setup exceeded our expectations!",
    image: "PS"
  },
  {
    id: 2,
    name: "Rajesh Gupta",
    event: "Corporate Annual Party",
    rating: 5,
    text: "Professional service and stunning decoration for our office party. The team understood our brand perfectly and delivered excellence.",
    image: "RG"
  },
  {
    id: 3,
    name: "Ananya Das",
    event: "Daughter's 5th Birthday",
    rating: 5,
    text: "The princess theme decoration was absolutely adorable! My daughter's face lit up when she saw the setup. Highly recommended!",
    image: "AD"
  },
  {
    id: 4,
    name: "Vikram Singh",
    event: "Engagement Ceremony",
    rating: 5,
    text: "Beautiful and romantic setup for our engagement. The team was punctual, creative, and made our special day even more memorable.",
    image: "VS"
  }
];

export const servicePackages = [
  {
    id: 1,
    name: "Essential",
    price: "Starting from ₹8,999",
    features: [
      "Basic balloon decoration",
      "Simple backdrop setup",
      "Table centerpieces",
      "Up to 50 guests",
      "2-hour setup time"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Premium",
    price: "Starting from ₹18,999",
    features: [
      "Advanced balloon artistry",
      "Custom themed backdrop",
      "Floral arrangements",
      "Complete venue styling",
      "Up to 100 guests",
      "Photo booth setup",
      "Professional lighting"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Luxury",
    price: "Custom Pricing",
    features: [
      "Fully customized design",
      "Premium floral decoration",
      "Grand entrance setup",
      "Stage & backdrop design",
      "Unlimited guests",
      "Complete event styling",
      "Dedicated design consultation",
      "Professional photography setup"
    ],
    popular: false
  }
];

export const aboutContent = {
  story: "Vrinaa Occasions was born from a passion for transforming ordinary spaces into extraordinary experiences. Based in the heart of Kolkata, we specialize in creating breathtaking event decorations that turn your celebrations into unforgettable memories.",
  mission: "Our mission is to bring your vision to life through creative design, meticulous attention to detail, and unwavering commitment to excellence. Every event is unique, and we pride ourselves on crafting personalized decoration solutions that reflect your style and celebrate your special moments.",
  values: [
    {
      title: "Creativity",
      description: "Innovative designs that push boundaries and create wow moments"
    },
    {
      title: "Quality",
      description: "Premium materials and flawless execution in every project"
    },
    {
      title: "Reliability",
      description: "Punctual service and dependable team you can trust"
    },
    {
      title: "Personalization",
      description: "Custom solutions tailored to your unique vision and style"
    }
  ]
};

export const contactInfo = {
  phone: "+91 8276892783",
  email: "harsh576hya576@gmail.com",
  instagram: "https://www.instagram.com/vrinaa.occasions/",
  instagramHandle: "@vrinaa.occasions",
  location: "Kolkata, West Bengal",
  hours: "Mon - Sun: 9:00 AM - 8:00 PM"
};
